import { Controller, useFormContext } from 'react-hook-form';

import { FormAutocompleteField } from '@/components/Form/FormAutocompleteField/FormAutocompleteField';
import type { CommonFieldDef } from '@/core/dcr/fields/types';

import { useDcrFormContext } from '../../_context/DcrFormContext';
import { useFieldLabel } from '../../_hooks/useFieldLabel';

type Props = {
	name: string;
	def: CommonFieldDef;
};

export const YearInput = ({ name, def }: Props) => {
	const { control } = useFormContext();
	const { picklists } = useDcrFormContext();
	const fieldLabel = useFieldLabel();

	return (
		<Controller
			name={name}
			control={control}
			render={({ field, fieldState }) => (
				<FormAutocompleteField
					id={name}
					name={field.name}
					label={fieldLabel(def)}
					options={picklists.yearOptions ?? []}
					defaultValue={
						typeof field.value === 'number' ? String(field.value) : ''
					}
					isRequired={def.required}
					indicateError={!!fieldState.error}
					isDirty={typeof field.value === 'number'}
					handleOnDropdownItemSelect={item => {
						const year = Number(item?.id);
						field.onChange(item && !Number.isNaN(year) ? year : undefined);
					}}
				/>
			)}
		/>
	);
};
